 
import React from "react";
import { Dialog } from "../../../components/Dialogs/Dialog";

import { AutomobileAssignedTo } from "./AssignedToID/AutomoibleAssignedTo";
import { HabitationalAssignedTo } from "./AssignedToID/HabitationalAssignedTo";
import { BusinessAssignedTo } from "./AssignedToID/BusinessAssignedTo";
import { CommAutoAssignedTo } from "./AssignedToID/CommAutoAssignedTo";
import { POLICIES } from "../../../constants/enums";

interface IAssignedToComponentProps {
  assignTo?: string;
  customerPolicyId: number | null;
  customerId: number | null;
  change_request_code: string | null;
  status: string;
  onComplete: () => void;
  onClose: () => void;
}

export const AssignedToDialog: React.FC<{
  open: boolean;
  customerPolicyId: number | null;
  customerId: number | null;
  change_request_code: string | null;
  policyType: string ;
  status: string ;
  assignedTo?: string;
 onComplete: (data?: {
    assigned_to_id: string;
    assigned_to_name: string | null;
  } ) => void;
  onClose: () => void;
}> = (props) => {
  const { open, onComplete, onClose, customerPolicyId , customerId, change_request_code, assignedTo , policyType, status } = props;

  const sharedProps: IAssignedToComponentProps = {
    assignTo: assignedTo,
    customerPolicyId: customerPolicyId,
    customerId: customerId,
    change_request_code: change_request_code,
    status: status,
    onComplete,
    onClose,
  };

  const renderAssignedToComponent = (
    policyType: string,
    props: IAssignedToComponentProps
  ) => {
    switch (policyType) {
      case POLICIES.AUTOMOBILE_POLICY:
        return <AutomobileAssignedTo {...props} />;
      case POLICIES.HABITATIONAL_POLICY:
        return <HabitationalAssignedTo {...props} />;
      case POLICIES.BUSINESS_POLICY:
        return <BusinessAssignedTo {...props} />;
      case POLICIES.COMMERCIAL_AUTO_POLICY:
        return <CommAutoAssignedTo {...props} />;
      default:
        return null;
    }
  };

  return (
    <>
      <Dialog open={open} title="Assigned To" onClose={onClose} size="sm" fullWidth>
        {sharedProps.customerPolicyId &&
          sharedProps.customerId &&
          sharedProps.change_request_code &&
          renderAssignedToComponent(policyType ?? "", sharedProps)}
      </Dialog>
    </>
  );
};
